module.exports = __webpack_public_path__ + "static/img/brown_papersq.82cd9f5.png";


//////////////////
// WEBPACK FOOTER
// ./~/light.js/lib/vendor/highlight.js/styles/brown_papersq.png
// module id = 247
// module chunks = 1 4